
@if (universalService.showSuccessToastMessage) {
  <div
    class="toast-main animated bounceInDown toast-main-addto-jiocloud">
    <div class="toast-msg">
      <div class="row m-0 p-0">
        <div class="col-1 p-0"><span class="NeueFileFilledSelected"></span></div>
        <div [ngClass]="universalService.showViewButton?'col-9 p-0':'col-11 p-0 pl-1'"><span class="msgCont">{{universalService.toastMessage}}</span></div>
        @if (universalService.showViewButton) {
          <div class="col-2 p-0">
            @if (universalService.MarkNewObjArray.length ==0 && universalService.showViewButton) {
              <span class="viewButton"
              (click)="viewFile()">View</span>
            }
            @if (universalService.MarkNewObjArray.length >=1 && universalService.showViewButton && !universalService.showPreview) {
              <span class="viewButton"
              (click)="viewFile()">View</span>
            }
          </div>
        }
      </div>
    </div>
  </div>
}

@if (universalService.showSuccessThirdPartyToastMessage) {
  <div
    class="toast-main animated bounceInDown toast-main-addto-jiocloud">
    <div class="toast-msg">
      <div class="row m-0 p-0">
        <div class="col-1 p-0"><span class="NeueFileFilledSelected"></span></div>
        <div [ngClass]="'col-11 p-0 pl-1'">
          <span class="msgCont">{{universalService.toastMessage}}
          <strong>{{universalService.thirdPartyEmail}}</strong>
        </span>
        </div>
      </div>
    </div>
  </div>
}

@if (universalService.showErrorToastMessage && !universalService.uploadStorageFullError) {
  <div class="toast-main animated bounceInDown">
    <div class="toast-msg">
      <h2>
        <span class="NeueDFilledError"></span>
        <span class="msgCont">{{universalService.toastMessage}}</span>
      </h2>
    </div>
  </div>
}


@if (universalService.uploadStorageFullError) {
  <div class="toast-main animated bounceInDown">
    <div class="toast-msg">
      <h2>
        <span class="NeueDFilledError"></span>
        <span class="msgCont">{{universalService.toastMessage}}</span>
      </h2>
    </div>
  </div>
}

@if (universalService.showWarningToastMessage) {
  <div class="toast-main animated bounceInDown">
    <div class="toast-msg">
      <h2>
        <span class="NeueDFilledError"></span>
        <span class="msgCont">{{universalService.toastMessage}}</span>
      </h2>
    </div>
  </div>
}
